import { __assign } from "tslib";
import * as React from 'react';
import { Action, Button } from '../components';
var nextSort = {
    none: 'asc',
    asc: 'desc',
    desc: 'none',
};
var sortIcons = {
    none: 'fas fa-sort',
    asc: 'fas fa-sort-up',
    desc: 'fas fa-sort-down',
};
export function useSortTable(initialRows, initialHeaders, sorterFunctions, sortableHeaderIds) {
    var _a = React.useState(['', -1, 'none']), sortingState = _a[0], setSortingState = _a[1];
    var headers = React.useMemo(function () {
        var oldHeader = sortingState[0], _ = sortingState[1], oldSort = sortingState[2];
        var handleOnSort = function (header, index) {
            if (oldHeader === header.id) {
                var newSort = nextSort[oldSort];
                setSortingState([header.id, index, newSort]);
            }
            else {
                var newSort = nextSort.none;
                setSortingState([header.id, index, newSort]);
            }
        };
        return initialHeaders.map(function (header, index) {
            return (sortableHeaderIds === null || sortableHeaderIds === void 0 ? void 0 : sortableHeaderIds.includes(header.id))
                ? __assign(__assign({}, header), { cell: (React.createElement(React.Fragment, null,
                        header.cell,
                        React.createElement(Action, { of: Button, icon: sortIcons[oldHeader === header.id ? oldSort : 'none'], title: "Sort", kind: "ghost", onClick: function () { return handleOnSort(header, index); } }))) }) : header;
        });
    }, [sortingState, initialHeaders, sortableHeaderIds]);
    var rows = React.useMemo(function () {
        var detailsRows = {};
        var finalRows = [];
        var sortableRows = [];
        var headerId = sortingState[0], headerIndex = sortingState[1], newSort = sortingState[2];
        if (newSort !== 'none') {
            // Splitting table rows into sortable and detail rows because we only want to sort the parent rows
            for (var i = 0; i < initialRows.length; i++) {
                var currentRow = initialRows[i];
                if (currentRow.hidden === undefined) {
                    sortableRows.push(currentRow);
                }
                else {
                    detailsRows[initialRows[i - 1].id] = currentRow;
                }
            }
            if (newSort === 'asc' || newSort === 'desc') {
                sortableRows.sort(function (a, b) {
                    var _a;
                    var cellA = a.cells[headerIndex];
                    var cellB = b.cells[headerIndex];
                    var sorter = sorterFunctions[headerId];
                    var sortResult = (_a = sorter === null || sorter === void 0 ? void 0 : sorter(cellA, cellB)) !== null && _a !== void 0 ? _a : 0;
                    return sortResult * (newSort === 'asc' ? 1 : -1);
                });
            }
            // Insert details rows into below their previous parent rows
            for (var _i = 0, sortableRows_1 = sortableRows; _i < sortableRows_1.length; _i++) {
                var parentRow = sortableRows_1[_i];
                finalRows.push(parentRow);
                if (detailsRows[parentRow.id]) {
                    finalRows.push(detailsRows[parentRow.id]);
                }
            }
            return finalRows;
        }
        return initialRows;
    }, [sortingState, initialRows]);
    return [rows, headers];
}
//# sourceMappingURL=useSortTable.js.map